let _config = {};

_config["API_HOST"] = "https://securestage.paytmpayments.com";
_config["STATIC_ASSET_HOST"] = "https://static-staging.paytmpayments.com";

module.exports = _config;



// WEBPACK FOOTER //
// ../config/dev.js